import { ComponentFactoryResolver, Type, ViewContainerRef } from '@angular/core';

import { Product } from './product';

import { BaseProductComponent } from 'src/app/main/components/shopping-cart/base-product/base-product.component';
import { IntegrationProductComponent } from 'src/app/main/components/shopping-cart/integration-product/integration-product.component';
import { PosPackProductComponent } from 'src/app/main/components/shopping-cart/pos-pack-product/pos-pack-product.component';
import { PosProductComponent } from 'src/app/main/components/shopping-cart/pos-product/pos-product.component';
import { QrProductComponent } from 'src/app/main/components/shopping-cart/qr-product/qr-product.component';
import { WebSiteProductComponent } from 'src/app/main/components/shopping-cart/web-site-product/web-site-product.component';
import { WixProductComponent } from 'src/app/main/components/shopping-cart/wix-product/wix-product.component';
import { IProductComponent } from './iproduct-component';

import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { LinkPagoProductComponent } from 'src/app/main/components/shopping-cart/link-pago-product/link-pago-product.component';


/**
 * Product attacher
 * Esta se utiliza para agregar dinamicamente componentes de producto al carrito de compra
 */
export class ProductAttacher {
    viewContainerRef: ViewContainerRef;
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        viewContainerRef: ViewContainerRef
    ) {
        this.viewContainerRef = viewContainerRef;
    }

    addProducts(products: Product[]): void {
        for (const product of products) {
            this.addProduct(product);
        }
    }

    addProduct(product: Product): void {

        if (this.isPosProduct(product)) {
            this.attachComponent(product, PosProductComponent);
        } else if (this.isQrProduct(product)) {
            this.attachComponent(product, QrProductComponent);
        } else if (this.isPackPosProduct(product)) {
            this.attachComponent(product, PosPackProductComponent);
        } else if (this.isIntegrationProduct(product)) {
            this.attachComponent(product, IntegrationProductComponent);
        } else if (this.isWebsiteProduct(product)) {
            this.attachComponent(product, WebSiteProductComponent);
        } else if (this.isWixProduct(product)) {
            this.attachComponent(product, WixProductComponent);
        } else if (this.islinkPagoProduct(product)) {
            this.attachComponent(product, LinkPagoProductComponent);
        } else {
            this.attachComponent(product, BaseProductComponent);
        }
    }

    private isPosProduct(product: Product): boolean {
        let isPos = false;
        switch (product.codigoProducto) {
            case CodigoProductoEnum.VENTA_MPOS:
            case CodigoProductoEnum.VENTA_MPOS_GARANTIA:
            case CodigoProductoEnum.PACK_VENTA_MPOS_LP:
            case CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA:
            case CodigoProductoEnum.ARRIENDO_MPOS:
            case CodigoProductoEnum.ARRIENDO_POS_MOVIL:
            case CodigoProductoEnum.ARRIENDO_POS_FIJO_INTERNET:
            case CodigoProductoEnum.ARRIENDO_POS_FIJO_CELULAR:
            case CodigoProductoEnum.ARRIENDO_POS_MOVIL_FERIA:
            case CodigoProductoEnum.ARRIENDO_POS_MOVIL_20DIAS:
            case CodigoProductoEnum.ARRIENDO_POS_MOVIL_90DIAS:
            case CodigoProductoEnum.ARRIENDO_SMARTPOS:
            case CodigoProductoEnum.ARRIENDO_LITE_POS:
            case CodigoProductoEnum.PACK_POS_MOVIL_LP:
                isPos = true;
                break;
        }
        return isPos;
    }

    private isQrProduct(product: Product): boolean {
        let isQr = false;
        if (product.codigoProducto === CodigoProductoEnum.COBRO_QR) {
            isQr = true;
        }
        return isQr;
    }

    private isPackPosProduct(product: Product): boolean {
        let isPackPos = false;
        switch (product.codigoProducto) {
            case CodigoProductoEnum.ARRIENDO_PACK_INTERNET:
                isPackPos = true;
                break;
            case CodigoProductoEnum.ARRIENDO_PACK_CELULAR:
                isPackPos = true;
                break;
        }
        return isPackPos;
    }

    private isIntegrationProduct(product: Product): boolean {
        let isIntegration = false;
        switch (product.codigoProducto) {
            case CodigoProductoEnum.INTEGRADOR_CLIENTE:
                isIntegration = true;
                break;
            case CodigoProductoEnum.INTEGRADOR_TRANSBANK:
                isIntegration = true;
                break;
            case CodigoProductoEnum.INTEGRA_MEDIO_PAGO_CON_TRANSBANK:
                isIntegration = true;
                break;
            case CodigoProductoEnum.INTEGRA_MEDIO_PAGO_POR_TU_CUENTA:
                isIntegration = true;
                break;
            case CodigoProductoEnum.CREA_TU_SITIO_WEB_CON_PST:
                isIntegration = true;
                break;
            case CodigoProductoEnum.CREA_TU_SITIO_WEB_CON_WIX:
                isIntegration = true;
                break;
        }
        return isIntegration;
    }

    private isWebsiteProduct(product: Product): boolean {
        let isWebsite = false;
        if (product.codigoProducto === CodigoProductoEnum.CREACION_SITIO_PST) {
            isWebsite = true;
        }
        return isWebsite;
    }


    private isWixProduct(product: Product): boolean {
        let isWix = false;
        switch (product.codigoProducto) {
            // case CodigoProductoEnum.INTEGRADOR_TRANSBANK:
            //     isWix = true;
            //     break;
            case CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX:
                isWix = true;
                break;
        }
        return isWix;
    }

    private islinkPagoProduct(product: Product): boolean {
        let isLinkPago = false;
        switch (product.codigoProducto) {
            case CodigoProductoEnum.PACK_VENTA_MPOS_LP:
            case CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA:
            case CodigoProductoEnum.LINK_PAGO:
            case CodigoProductoEnum.PACK_POS_MOVIL_LP:
                isLinkPago = true;
                break;
            case CodigoProductoEnum.COBRA_CON_LINK_PAGO:
                isLinkPago = true;
                break;
        }
        return isLinkPago;
    }

    /**
     * Agrega componente de producto en contenedor
     * @param product
     * @param productComponent
     */
    attachComponent(product: Product, productComponent: Type<IProductComponent>): void {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory<IProductComponent>(productComponent);
        const viewContainerRef = this.viewContainerRef;
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.product = product;
    }

}
